import { render, staticRenderFns } from "./ManualCriticismDialog.vue?vue&type=template&id=1b62ca15&scoped=true&style=background%3A%20var(--v-muted-base)&"
import script from "./ManualCriticismDialog.vue?vue&type=script&lang=js&"
export * from "./ManualCriticismDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManualCriticismDialog.vue?vue&type=style&index=0&id=1b62ca15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b62ca15",
  null
  
)

export default component.exports